/** Formatação para exibição. Sem regra de negócio — só tradução para o olho humano. */

const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

export function formatBytes(bytes: number): string {
  if (bytes <= 0) return '0 B';
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), BYTE_UNITS.length - 1);
  const value = bytes / Math.pow(1024, exponent);
  const decimals = exponent === 0 ? 0 : value < 10 ? 1 : 0;
  return `${value.toFixed(decimals).replace('.', ',')} ${BYTE_UNITS[exponent]}`;
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('pt-BR');
}

export function formatPercent(ratio: number): string {
  return `${(ratio * 100).toFixed(1).replace('.', ',')}%`;
}

/**
 * `"2026-08-18"` → `"18/08"`.
 *
 * Data de negócio é string `YYYY-MM-DD` e é formatada **sem** passar por `new Date()`:
 * construir um `Date` a partir dela aplicaria o fuso do dispositivo e poderia exibir o
 * dia anterior (RN-120).
 */
export function formatShortDate(businessDate: string): string {
  const [, month, day] = businessDate.split('-');
  return month === undefined || day === undefined ? businessDate : `${day}/${month}`;
}

/** `"2026-08-18"` → `"18/08/2026"`, pela mesma razão acima. */
export function formatBusinessDate(businessDate: string): string {
  const [year, month, day] = businessDate.split('-');
  return year === undefined || month === undefined || day === undefined
    ? businessDate
    : `${day}/${month}/${year}`;
}

const MONTH_SHORT = [
  'jan',
  'fev',
  'mar',
  'abr',
  'mai',
  'jun',
  'jul',
  'ago',
  'set',
  'out',
  'nov',
  'dez',
];

/** `"2026-10-05"` → `"5 out"`, sem o ano e sem zero à esquerda — o rótulo de uma semana. */
export function formatDayMonthName(businessDate: string): string {
  const [, month, day] = businessDate.split('-');
  const name = month === undefined ? undefined : MONTH_SHORT[Number(month) - 1];
  return day === undefined || name === undefined ? businessDate : `${String(Number(day))} ${name}`;
}

/** `"2026-10-05"` → `"5/10"`: o dia e o mês curtos, para a lista por semana. */
export function formatDayMonth(businessDate: string): string {
  const [, month, day] = businessDate.split('-');
  return month === undefined || day === undefined
    ? businessDate
    : `${String(Number(day))}/${String(Number(month))}`;
}
